import React from 'react';
import { Box, Typography } from '@mui/material';
import DisciplineAccessControl from '../common/DisciplineAccessControl';

const HighMastAnalytics = () => {
  return (
    <DisciplineAccessControl requiredDiscipline="Vertical Asset">
      <Box sx={{ maxWidth: '100%' }}>
        {/* Placeholder for future analytics */}
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 3,
          mb: 3
        }}>
          {/* Defect Distribution */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '350px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Defect Distribution
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Breakdown by defect type:
                <br />
                Corrosion, Paint Peeling, Vegetation,
                <br />
                Moss, Cracks, Slanting, etc.
              </Typography>
            </Box>
          </Box>

          {/* Severity Breakdown */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '350px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Severity Breakdown
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Severity Level 1 / 2 / 3,
                <br />
                Binary (Yes/No) defects, and
                <br />
                Degree-based (Slanting) assessment
              </Typography>
            </Box>
          </Box>

          {/* Inspection Trend */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '350px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Inspection Trend
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Monthly inspection counts,
                <br />
                UAV vs Camera sessions, and
                <br />
                images processed over time
              </Typography>
            </Box>
          </Box>

          {/* SLA Compliance */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '350px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                SLA Compliance
              </Typography>
              <Typography variant="caption" color="text.secondary">
                On-time resolution rate,
                <br />
                average resolution time, and
                <br />
                overdue case aging analysis
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Top Assets Table Placeholder */}
        <Box
          sx={{
            p: 3,
            borderRadius: 2,
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
            border: '2px dashed',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '250px',
            backgroundColor: 'background.paper'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Top Assets by Defect Count
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Ranked list of High Mast assets
              <br />
              with highest defect counts and
              <br />
              click-to-drill-down navigation
            </Typography>
          </Box>
        </Box>
      </Box>
    </DisciplineAccessControl>
  );
};

export default HighMastAnalytics;
